import { NgModule } from '@angular/core';
import { SecurityRoutingModule } from './security-routing.module';
import { SecurityComponent } from './security/security.component';
import {TemplateModule} from '@project/shared/template/template.module';


@NgModule({
  declarations: [SecurityComponent],
  imports: [
    TemplateModule,
    SecurityRoutingModule,
  ]
})
export class SecurityModule { }
